export default {
  en: {
    title: 'Buy now. Pay with Klarna at your own pace.',
    subTitle: 'Get what you love, choose how you pay.',
    timelineHeader: 'How it works',
    timelineItems: [
      {
        title: 'At checkout select Klarna',
        description: ''
      },
      {
        title: 'Choose your payment plan',
        description: 'Different payment plans may be shown depending on the purchase amount and credit score.'
      },
      {
        title: 'Complete your checkout',
        description: 'The amount will be charged based on the payment plan you chose.'
      }
    ]
  },
  nl: {
    title: 'Shop nu. Betaal met Klarna in je eigen tempo.',
    subTitle: 'Koop wat je leuk vindt, kies hoe je betaalt.',
    timelineHeader: 'Hoe werkt het?',
    timelineItems: [
      {
        title: 'Kies Klarna bij het afrekenen',
        description: 'Kies Klarna bij het afrekenen'
      },
      {
        title: 'Kies je betalingsplan',
        description: 'Afhankelijk van het aankoopbedrag en de kredietscore kunnen verschillende betalingsplannen worden weergegeven.'
      },
      {
        title: 'Voltooi de aankoop',
        description: 'Het bedrag wordt in rekening gebracht op basis van het door jou gekozen betalingsplan.'
      }
    ]
  }
}
